export default __webpack_public_path__ + "static/media/9D.3d612a15.svg";